var $body, itemActiveClass, itemClass, sidebarOpenClass;

itemClass = 'sidebar__item__toggle';

itemActiveClass = itemClass + '--active';

sidebarOpenClass = 'sidebar-open';

$body = $('body');

$('.' + itemClass).on('click', function(e) {
  var $item, $items;
  if ($(this).attr('href') === '#') {
    e.preventDefault();
    $item = $(this);
    $items = $('.' + itemClass);
    if ($item.hasClass(itemActiveClass)) {
      $items.removeClass(itemActiveClass);
      $body.removeClass(sidebarOpenClass);
      if ($item.hasClass('search-toggle')) {
        $('.sidebar-element--search').find('input').blur();
      }
    } else {
      $items.removeClass(itemActiveClass);
      $item.addClass(itemActiveClass);
      $body.addClass(sidebarOpenClass);
      if ($item.hasClass('search-toggle')) {
        $('.sidebar-element--search').find('input').focus();
      }
    }
    $.each($items, function() {
      var $element, elementData, openClass;
      $element = $(this);
      elementData = $element.data('element');
      openClass = 'sidebar-' + elementData + '-open';
      $body.removeClass(openClass);
      if ($element.hasClass(itemActiveClass)) {
        return $body.addClass(openClass);
      }
    });
    return false;
  } else if ($(this).attr('href') === '#print') {
    e.preventDefault();
    window.print();
    return false;
  }
});

$(document).on('click', function(e) {
  if (!$(e.target).is('.sidebar-search-container form, .sidebar-search-container form *, .sidebar-search-container h3')) {
    if ($('body').hasClass('sidebar-open')) {
      $('body').removeClass('sidebar-open sidebar-search-open');
      return $('.sidebar__item__toggle').removeClass('sidebar__item__toggle--active');
    }
  }
});

// ---
// generated by coffee-script 1.9.2